var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"container"},[_c('iframe',{staticStyle:{"width":"100%","height":"100vh"},attrs:{"src":_vm.flutterPageUrl,"frameborder":"0"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }